import React, { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'

import { TopNav } from '../TopNav'
import { Footer } from '../Footer/Footer'

import OutsideClickHandler from 'react-outside-click-handler'
import 'normalize.css/normalize.css'
import './layout.css'
import '../../components/Layout/normalize.css'
import { AlertManager } from '../../components/Alert/AlertManager'
import { GlobalLoadingBar } from '../../components/LoadingBar/GlobalLoadingBar'
import { BaseLayout } from './Components/BaseLayout'
import { Body } from './Components/Body'
import { Content } from './Components/Content'
import PaymentSuccessModal from '../../components/Modal/PaymentSuccessModal'
import LoadingModal from '../../components/Modal/LoadingModal'
import TopNavWithoutSearchBar from '../TopNav/TopNavWithoutSearchBar'
import { TopNavColor } from '../TopNav/TopNav.types'
import FloatingBottomAuthPanel from '../Panel/FloatingBottomAuthPanel'
import { showFloatingAuthPaenl } from '../../states/panels/actions'
import { useAppDispatch } from '../../hooks/useAppDispatch'
import AuthModalManager from '../../components/Modal/AuthModalManager'
import LazyPaymentModal from '../../components/Modal/Lazy/LazyPaymentModal'

type LayoutProps = {
  children: React.ReactNode
  className?: string
  pathname: string
  isShowSearchBar?: boolean
  onSearchTextBoxFocus?: () => void
  onSearchTextBoxBlur?: () => void
  contentStyle?: React.CSSProperties
  topNavColor?: TopNavColor
}

const Layout = ({
  children,
  className,
  pathname,
  isShowSearchBar = true,
  topNavColor,
  onSearchTextBoxFocus,
  onSearchTextBoxBlur,
  contentStyle,
}: LayoutProps) => {
  const dispatch = useAppDispatch()
  const [isShowSearchBarClicked, setIsShowSearchBarClicked] =
    useState<boolean>(false)
  const canScroll = useSelector(({ scrolling }: any) => scrolling.canScroll)
  useEffect(() => {
    setTimeout(() => {
      dispatch(showFloatingAuthPaenl())
    }, 5000)
  }, [])
  return (
    <>
      <GlobalLoadingBar />
      <BaseLayout className={className}>
        <AlertManager />
        <AuthModalManager />
        <OutsideClickHandler
          onOutsideClick={() => setIsShowSearchBarClicked(false)}
        >
          {isShowSearchBar || isShowSearchBarClicked ? (
            <TopNav
              pathname={pathname}
              onSearchTextBoxFocus={onSearchTextBoxFocus}
              onSearchTextBoxBlur={onSearchTextBoxBlur}
            />
          ) : (
            <TopNavWithoutSearchBar
              color={topNavColor}
              onShowSearchBar={() => setIsShowSearchBarClicked(true)}
            />
          )}
        </OutsideClickHandler>
        <Body scrollable={canScroll} id="scroll-body">
          <Content style={contentStyle}>{children}</Content>
          <Footer />
        </Body>
      </BaseLayout>
      <LazyPaymentModal />
      <PaymentSuccessModal />
      <LoadingModal />
      <FloatingBottomAuthPanel />
    </>
  )
}

export { Layout }
